import { queryOptions, useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import customerGroupQueryKeys from './customerGroupQueryKeys'
import { getCustomerGroups } from '../service/customerGroupService'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import { Company } from '../../../types/company/Company'
import { CustomerGroup } from '../../../types/customer/customer'

export const useCustomerGroups = <TData = CustomerGroup[]>(
  companyId?: Company['id'],
  select?: (data: CustomerGroup[]) => TData,
  enabled = true
) =>
  useQuery(
    queryOptions({
      queryKey: customerGroupQueryKeys.list({ companyId }),
      queryFn: getCustomerGroups,
      enabled: !!companyId && enabled,
      gcTime: 15 * 60 * 1000,
      select: data => {
        const sorted = [...data].sort((a, b) => a.name.localeCompare(b.name))
        return select ? select(sorted) : (sorted as TData)
      }
    })
  )

export const useCtxCustomerGroups = () => {
  const companyId = useSelector(contextCompanyIdSelector)!
  return useCustomerGroups(companyId)
}
